export default __webpack_public_path__ + "static/media/cif-jp.0e1e4c8f.svg";